import React from 'react';

import {useSelector} from 'react-redux';

import {StepLane} from './StepLane';
import {StepLaneDiff} from './StepLaneDiff';

import {LaneSerializedType} from 'sweet-types';

interface Props {
  stepLaneId: string | null;
  laneDiff?: {new: string | null; old: string | null};
}

export function StepLaneItem({stepLaneId, laneDiff}: Props) {
  const lane: LaneSerializedType | null = useSelector((state) =>
    stepLaneId != null ? state.lanes.byId[stepLaneId] : null
  );

  return (
    <div className="d-flex flex-wrap justify-content-between">
      <div className="mb-2">
        {laneDiff != null ? (
          <StepLaneDiff laneDiff={laneDiff} />
        ) : lane != null ? (
          <StepLane lane={lane} />
        ) : null}
      </div>
    </div>
  );
}
